export default {
  home: {
    missing_order_no: 'Missing order number',
    order_load_failed: 'Failed to load order info: '
  },
  wallet: {
    loading: 'Loading...',
    no_available_wallet: 'No available {wallet} in current browser.',
    apple_pay_fallback: 'Requires Safari + Apple Wallet available card + HTTPS; Apple Pay domain verification is required in Stripe Dashboard for production.',
    google_pay_fallback: 'Requires Chrome + Google Pay available account/card + HTTPS; Please confirm Google Pay is enabled in Stripe Dashboard for production.',
    cashapp_pay_fallback: 'Please confirm Cash App Pay is enabled in Stripe Dashboard and supported in the current region/account.',
    default_fallback: 'Please confirm the corresponding payment method is enabled in Stripe Dashboard and use a real HTTPS domain for production.',
    init_failed: 'Initialization failed: ',
    missing_order_no: 'Missing order number',
    creating_stripe_session: 'Creating Stripe payment session...',
    backend_missing_keys: 'Backend did not return publishableKey or clientSecret',
    payment_component_load_failed: 'Failed to load payment component',
    payment_canceled: 'Payment canceled',
    confirming_payment: 'Confirming payment...',
    payment_confirm_no_result: 'No result returned from payment confirmation',
    redirecting_cashapp: 'Redirecting to Cash App Pay...',
    payment_failed: 'Payment failed: ',
    opening_cashapp_auth: 'Opening Cash App authorization page...',
    cashapp_auth_failed: 'Cash App authorization failed: '
  },
  return: {
    payment_success: 'Payment successful',
    processing: 'Processing...',
    requires_action: 'Requires action',
    payment_incomplete_or_canceled: 'Payment incomplete or canceled',
    payment_canceled: 'Payment canceled',
    showing_payment_result: 'Showing payment result...',
    status_label: 'Status: '
  }
}
